import { message } from 'antd';

const KEY = 'media-upload';

/**
 * Progression d'un envoi qui n'a pas d'ancrage visuel (collage sur le canvas,
 * cellule de tableau). Sans elle, un fichier de plusieurs dizaines de
 * mégaoctets fait passer l'éditeur pour figé.
 *
 * `duration: 0` : le message reste tant qu'on ne le retire pas — un envoi long
 * ne doit pas voir sa progression disparaître au bout de trois secondes.
 */
export const showUploadProgress = (percent) => {
  message.loading({
    content: percent == null
      ? 'Envoi en cours…'
      : `Envoi en cours — ${percent} %`,
    key: KEY,
    duration: 0,
  });
};

export const hideUploadProgress = () => message.destroy(KEY);
